
import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { Percent, Calendar, Clock, Shield } from "lucide-react";

const Benefits: React.FC = () => {
  return (
    <section className="py-8 md:py-16 bg-white px-4 md:px-6">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-6 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 md:mb-4">
            Gestão fiscal otimizada e maior lucratividade para você e seu negócio
          </h2>
          <p className="text-base md:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto">
            A TaxHealth identifica oportunidades legais para reduzir a carga tributária, executando todo o serviço tributário com segurança e transparência.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8">
          <BenefitCard 
            icon={<Percent className="h-6 w-6 md:h-8 md:w-8 text-blue-500" />}
            title="Redução de até 65%"
            description="Redução de até 65% da carga tributária mensal de forma 100% administrativa."
          />
          
          <BenefitCard 
            icon={<Shield className="h-6 w-6 md:h-8 md:w-8 text-blue-500" />}
            title="Especialistas tributários"
            description="Acesso a especialistas em assessoria e consultoria tributária."
          />
          
          <BenefitCard 
            icon={<Calendar className="h-6 w-6 md:h-8 md:w-8 text-blue-500" />}
            title="Restituição de 60 meses"
            description="Restituição de valores pagos incorretamente nos últimos 60 meses de forma administrativa."
          />
          
          <BenefitCard 
            icon={<Clock className="h-6 w-6 md:h-8 md:w-8 text-blue-500" />}
            title="Gestão otimizada"
            description="Gestão fiscal otimizada e maior lucratividade para seu negócio."
          />
        </div>
      </div>
    </section>
  );
};

interface BenefitCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const BenefitCard: React.FC<BenefitCardProps> = ({ icon, title, description }) => {
  return (
    <Card className="transition-all duration-300 hover:shadow-md h-full border-none shadow-sm bg-blue-50 bg-opacity-50">
      <CardContent className="pt-6 p-3 md:p-6">
        <div className="flex flex-col items-center text-center h-full">
          <div className="mb-4 p-3 bg-white rounded-full shadow-sm">
            {icon}
          </div>
          <h3 className="text-xl font-semibold text-gray-900 mb-2">{title}</h3>
          <p className="text-gray-600">{description}</p>
        </div>
      </CardContent>
    </Card>
  );
};

export default Benefits;
